import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

import Transition from '@ember/routing/-private/transition';
import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import ResetPasswordNewPasswordController from 'cio/pods/reset-password/new-password/controller';

export default class ResetPasswordRoute extends Route {
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;

  afterModel(_model: Record<string, any>, transition: Transition) {
    if (!transition.to.queryParams.resetPasswordToken) {
      this.alerts.error(
        'resetPassword.missingResetPasswordToken',
        "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        undefined,
        0,
      );
    }

    return super.afterModel(_model, transition);
  }

  setupController(controller: ResetPasswordNewPasswordController, model: Record<string, any>, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaultProperties();
  }
}
